import React from 'react';
import { Alert } from 'react-bootstrap';

interface CustomAlertProps {
  variant: string;
  children: React.ReactNode;
}

const CustomAlert: React.FC<CustomAlertProps> = ({ variant, children }) => {
  return (
    <Alert variant={variant} style={{ padding: '5px' }}>
      {children}
    </Alert>
  );
};

export default CustomAlert;